var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0463 0.182045L19.0463 19.1772H20.9565L20.9565 0.182045H19.0463Z",
    fill: "#BFFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6507 1.08825L0.260864 18.5366L1.6116 19.8182L20.0014 2.36984L18.6507 1.08825Z",
    fill: "#BFFF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9564 0.181885L0.936279 0.181885L0.936279 1.99434L20.9564 1.99434V0.181885Z",
    fill: "#BFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cca081e0d4368425e62179f84196b085.svg";
export { ForwardRef as ReactComponent };